import React from 'react';
import { Link } from 'react-router-dom';
import './NewHomePage.scss';
// Coat of arms and hero photography
import logo from '../../images/IconsLogos/ttcoatarms.png';
import heroPhoto from '../../images/BackgroundImages/tteveryoneregionals.JPEG';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AboutPillars from '../AboutPillars/AboutPillars';
import Reveal from '../Reveal/Reveal';

// Scrolls smoothly to the pillars section, offsetting for the fixed nav bar.
function scrollToPillars(event) {
  event.preventDefault();
  const pillarsSection = document.getElementById('AboutSection');
  if (!pillarsSection) return;
  const yOffset = -80;
  const y = pillarsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

// Light, collegiate homepage: the coat of arms and a chapter photograph as
// clean plates, followed by the three pillars.
function NewHome() {
  return (
    <div className="home-container">
      <section className="home-hero" aria-label="Theta Tau at Cal Poly">
        <div className="home-hero-content">
          <div className="home-hero-copy">
            <Reveal as="div" variant="rise" index={0} className="home-hero-crest-wrap">
              <img className="home-hero-crest" src={logo} alt="THETA TAU COAT OF ARMS" />
            </Reveal>
            <Reveal as="h1" variant="mask" index={0} className="home-hero-title">
              Theta Tau
            </Reveal>
            <Reveal as="p" variant="rise" index={1} className="home-hero-subtitle">
              The Foremost Professional Co-ed Engineering Fraternity at Cal Poly San Luis Obispo
            </Reveal>
          </div>

          <Reveal as="div" variant="rise" index={2} className="home-hero-actions">
            <Link className="btn btn--filled" to="/rush">
              Recruitment
              <ArrowForwardIcon className="btn-icon" fontSize="inherit" />
            </Link>
            <a className="btn btn--outline" href="#AboutSection" onClick={scrollToPillars}>
              Learn More
            </a>
          </Reveal>
        </div>

        <Reveal as="div" variant="plate" index={1} className="home-hero-plate">
          <img
            className="home-hero-photo"
            src={heroPhoto}
            alt="Theta Tau brothers at a Regional Convention"
          />
        </Reveal>
      </section>

      <div id="AboutSection" className="AboutSection">
        <AboutPillars />
      </div>
    </div>
  );
}

export default NewHome;
